import classes from "./ActionButton.module.css";
import util from "../../../styles/utilities.module.css";
import { Tooltip } from "@mui/material";

// variant options: 'primary' (blue), 'secondary' (accent/orange), 'ghost' (neutral)
const ActionButton = ({
  text,
  subText,
  handleOnClick,
  buttonType,
  isDisabled,
  variant = 'primary',
  customClass = "",
  tooltiptext,
}) => {
  const handleClick = (event) => {
    handleOnClick(event);
  };

  // Map variant to color style (from utilities.module.css)
  const variantBase = {
    primary: `${util.btn}`,
    secondary: `${util.btn} ${util['btn--secondary']}`,
    ghost: `${util.btn} ${util['btn--ghost']}`,
  }[variant] || `${util.btn}`; // fallback to primary

  // Layout width class: ghost uses compact width, others use full width
  const layoutClass = variant === 'ghost' ? classes['action-button-compact'] : classes['action-button'];

  const base = `${variantBase} ${layoutClass}`;
  const btnClass = subText ? `${base} ${classes['has-subtext']}` : base;

  const content = subText ? (
    <span className={classes.content}>
      <span className={classes['main-text']}>{text}</span>
      <span className={classes['small-text']}>{subText}</span>
    </span>
  ) : (
    text
  );

  return tooltiptext ? (
    <Tooltip arrow={true} placement="top" title={<p style={{ fontSize: "14px" }}>{tooltiptext}</p>}>
      <button
        name={text}
        className={`${btnClass} ${customClass}`}
        onClick={handleClick}
        type={buttonType}
        disabled={isDisabled}
      >
        {content}
      </button>
    </Tooltip>
  ) : (
    <button
      name={text}
      className={`${btnClass} ${customClass}`}
      onClick={handleClick}
      type={buttonType}
      disabled={isDisabled}
    >
      {content}
    </button>
  );
};

export default ActionButton;
